function match<T extends { type: string }, R>(
  x: T,
  patterns: { [P in T['type']]: (x: T extends { type: P } ? T : never) => R },
): R {
    if (x.type === 'ShowcaseStaticWidget') {
    const matchedFunc = (patterns as any)[x.widgetId];
    return matchedFunc && matchedFunc(x);
  }
  const matchedFunc = (patterns as any)[x.type];
  return matchedFunc && matchedFunc(x);
}

export default match;
